<div class="freightmancer-header" style="background: linear-gradient(135deg, #6c63ff, #4a47b1); color: white; padding: 16px; border-radius: 8px;">
  <i class="fas fa-hat-wizard freightmancer-header__icon"></i>
  <h1 class="freightmancer-header__title">Freightmancer</h1>
</div>

<mat-horizontal-stepper linear class="freightmancer-stepper modern-stepper" #stepper>

  <!-- Step 1: Customer -->
  <mat-step [stepControl]="customerForm">
    <ng-template matStepLabel >
      <i class="fas fa-user step-label__icon"></i>Customer
    </ng-template>
    <mat-card class="step-card">
      <form [formGroup]="customerForm">
        <app-contact-autocomplete
          placeholder="Search customer…"
          [type]="'customer_contact_list'"
          (selected)="onCustomerSelected($event)">
        </app-contact-autocomplete>

        <div class="address-row">
          <mat-form-field appearance="outline"  color="primary" class="enhanced-input">
            <mat-label>Customer Address</mat-label>
            <mat-select formControlName="customer_address">
              <mat-option *ngFor="let a of customerAddresses" [value]="a.value">{{ a.label }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline"  color="primary" class="enhanced-input">
            <mat-label>Postal Code</mat-label>
            <input matInput formControlName="customer_postal_code">
          </mat-form-field>
        </div>

        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>Documentation</mat-expansion-panel-header>
          <div class="checkbox-group">
            <mat-checkbox formControlName="customer_shipping_bol">Shipping BOL</mat-checkbox>
            <mat-checkbox formControlName="customer_invoice_bol">Invoice BOL</mat-checkbox>
            <mat-checkbox formControlName="customer_invoice_pod_required">Invoice POD</mat-checkbox>
            <mat-checkbox formControlName="customer_invoice_po_required">PO Number</mat-checkbox>
            <mat-form-field *ngIf="customerForm.get('customer_invoice_po_required')!.value" appearance="fill" color="primary" class="enhanced-input">
              <mat-label>PO Number</mat-label>
              <input matInput formControlName="customer_invoice_po">
            </mat-form-field>
            <mat-checkbox formControlName="customer_rate_quote">Rate Quote Invoice</mat-checkbox>
            <mat-checkbox formControlName="customer_consignee_agreement">Consignee Agreement</mat-checkbox>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>Notifications</mat-expansion-panel-header>
          <div class="checkbox-group">
            <mat-checkbox formControlName="customer_at_pickup_notification">At Pick‑Up</mat-checkbox>
            <mat-checkbox formControlName="customer_delayed_pickup_notification">Delayed Pick‑Up</mat-checkbox>
            <mat-checkbox formControlName="customer_at_delivery_notification">At Delivery</mat-checkbox>
            <mat-checkbox formControlName="customer_delayed_delivery_notification">Delayed Delivery</mat-checkbox>
            <mat-checkbox formControlName="customer_assessorials_incurred_notification">Assessorials Incurred</mat-checkbox>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>Transportation</mat-expansion-panel-header>
          <div class="checkbox-group">
            <mat-checkbox formControlName="customer_csa">CSA</mat-checkbox>
            <mat-checkbox formControlName="customer_fast">FAST</mat-checkbox>
            <mat-checkbox formControlName="customer_ace">ACE</mat-checkbox>
            <mat-checkbox formControlName="customer_aci">ACI</mat-checkbox>
            <mat-checkbox formControlName="customer_ct_pat">CT PAT</mat-checkbox>
            <mat-checkbox formControlName="customer_canada_bond">Canada Bond</mat-checkbox>
            <mat-checkbox formControlName="customer_us_bond">US Bond</mat-checkbox>
            <mat-checkbox formControlName="customer_hazmat">HAZMAT</mat-checkbox>
            <mat-checkbox formControlName="customer_protect_from_freezing">Protect From Freezing</mat-checkbox>
            <mat-checkbox formControlName="customer_heated">Heated</mat-checkbox>
            <mat-checkbox formControlName="customer_refrigeration">Refrigeration</mat-checkbox>
            <mat-checkbox formControlName="customer_food_grade">Food Grade</mat-checkbox>
          </div>
        </mat-expansion-panel>

        <div class="row">
          <mat-form-field appearance="outline"  color="primary" class="enhanced-input">
            <mat-label>Rate Method</mat-label>
            <mat-select formControlName="rate_method">
              <mat-option value="1">Cubic Feet</mat-option>
              <mat-option value="2">Weight</mat-option>
              <mat-option value="3">Linear Feet</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="actions">
          <button mat-raised-button color="primary" matStepperNext [disabled]="customerForm.invalid">Next</button>
        </div>
      </form>
    </mat-card>
  </mat-step>

  <!-- Step 2: Shipper -->
  <mat-step [stepControl]="shipperForm">
    <ng-template matStepLabel>
      <i class="fas fa-box step-label__icon"></i>Shipper
    </ng-template>
    <mat-card class="step-card">
      <form [formGroup]="shipperForm">

        <app-contact-autocomplete
          placeholder="Search shipper…"
          [type]="'shipper_contact_list'"
          (selected)="onShipperSelected($event)">
        </app-contact-autocomplete>

        <div class="address-row">
          <mat-form-field appearance="outline"  color="primary" class="enhanced-input">
            <mat-label>Shipper Address</mat-label>
            <mat-select formControlName="shipper_address">
              <mat-option *ngFor="let a of shipperAddresses" [value]="a.value">{{ a.label }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline"  color="primary" class="enhanced-input">
            <mat-label>Postal Code</mat-label>
            <input matInput formControlName="shipper_postal_code">
          </mat-form-field>
        </div>

        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>Shipper Details</mat-expansion-panel-header>
          <div class="checkbox-group">
            <mat-checkbox formControlName="shipper_loading_dock">Loading Dock</mat-checkbox>
            <mat-checkbox formControlName="shipper_pickup_tailgate">Tailgate at Pick‑Up</mat-checkbox>
            <mat-checkbox formControlName="shipper_truck_space">Truck Space</mat-checkbox>
            <mat-checkbox formControlName="shipper_pickup_straight_truck">Straight Truck</mat-checkbox>
            <mat-checkbox formControlName="shipper_bol_required">Requires BOL</mat-checkbox>
          </div>
        </mat-expansion-panel>

        <div class="row">
          <mat-form-field appearance="outline"  color="primary" class="enhanced-input">
            <mat-label>Pick‑Up Reference</mat-label>
            <input matInput formControlName="shipper_pickup_reference">
          </mat-form-field>
          <mat-form-field appearance="outline"  color="primary" class="enhanced-input">
            <mat-label>Estimated Pickup Date</mat-label>
            <input matInput [matDatepicker]="shipperEstimatedPicker" formControlName="estimated_date_shipper">
            <mat-datepicker-toggle matIconSuffix [for]="shipperEstimatedPicker"></mat-datepicker-toggle>
            <mat-datepicker #shipperEstimatedPicker></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="outline"  color="primary" class="enhanced-input">
            <mat-label>Estimated Pickup Time</mat-label>
            <input matInput type="time" formControlName="estimated_time_start_shipper">
          </mat-form-field>
        </div>

        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>Location Type</mat-expansion-panel-header>
          <div class="checkbox-group">
            <mat-checkbox formControlName="shipper_is_residential">Residential</mat-checkbox>
            <mat-checkbox formControlName="shipper_is_commercial">Commercial</mat-checkbox>
            <mat-checkbox formControlName="shipper_is_job_site">Job Site</mat-checkbox>
          </div>
        </mat-expansion-panel>

        <div *ngIf="shipperForm.get('shipper_is_job_site')!.value">
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>Job Site Details</mat-expansion-panel-header>
            <div class="checkbox-group">
              <mat-checkbox formControlName="shipper_lift_lull">Forklift or Lull</mat-checkbox>
              <mat-checkbox formControlName="shipper_call_site">Call Site</mat-checkbox>
              <mat-checkbox formControlName="shipper_unmanned_job_site">Unmanned Job Site</mat-checkbox>
              <mat-form-field appearance="outline"  color="primary" class="enhanced-input">
                <mat-label>Job Site Contact Name</mat-label>
                <input matInput formControlName="shipper_job_site_contact_name">
              </mat-form-field>
              <mat-form-field appearance="outline"  color="primary" class="enhanced-input">
                <mat-label>Job Site Contact Phone</mat-label>
                <input matInput formControlName="shipper_job_site_contact_phone">
              </mat-form-field>
            </div>
          </mat-expansion-panel>
        </div>

        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>Other Site Info</mat-expansion-panel-header>
          <div class="checkbox-group">
            <mat-checkbox formControlName="shipper_is_convention_center">Convention Center</mat-checkbox>
            <mat-checkbox formControlName="shipper_is_pop_up">Pop‑Up Store</mat-checkbox>
            <mat-checkbox formControlName="appointment_shipper">Appointment required?</mat-checkbox>
          </div>
        </mat-expansion-panel>

        <div *ngIf="shipperForm.get('appointment_shipper')!.value" class="row">
          <mat-form-field appearance="outline"  color="primary" class="enhanced-input">
            <mat-label>Appointment Date</mat-label>
            <input matInput [matDatepicker]="shipperAppointmentPicker" formControlName="appointment_date_shipper">
            <mat-datepicker-toggle matIconSuffix [for]="shipperAppointmentPicker"></mat-datepicker-toggle>
            <mat-datepicker #shipperAppointmentPicker></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="outline"  color="primary" class="enhanced-input">
            <mat-label>Window Start</mat-label>
            <input matInput type="time" formControlName="appointment_time_start_shipper">
          </mat-form-field>
          <mat-form-field appearance="outline"  color="primary" class="enhanced-input">
            <mat-label>Window End</mat-label>
            <input matInput type="time" formControlName="appointment_time_end_shipper">
          </mat-form-field>
        </div>

        <div class="actions">
          <button mat-button color="accent" matStepperPrevious>Back</button>
          <button mat-raised-button color="primary" matStepperNext [disabled]="shipperForm.invalid">Next</button>
        </div>
      </form>
    </mat-card>
  </mat-step>

  <!-- Step 3: Consignee -->
  <mat-step [stepControl]="consigneeForm">
    <ng-template matStepLabel>
      <i class="fas fa-box-open step-label__icon"></i>Consignee
    </ng-template>
    <mat-card class="step-card">
      <form [formGroup]="consigneeForm">

        <app-contact-autocomplete
          placeholder="Search consignee…"
          [type]="'consignee_contact_list'"
          (selected)="onConsigneeSelected($event)">
        </app-contact-autocomplete>

        <div class="address-row">
          <mat-form-field appearance="outline"  color="primary" class="enhanced-input">
            <mat-label>Consignee Address</mat-label>
            <mat-select formControlName="consignee_address">
              <mat-option *ngFor="let a of consigneeAddresses" [value]="a.value">{{ a.label }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline"  color="primary" class="enhanced-input">
            <mat-label>Postal Code</mat-label>
            <input matInput formControlName="consignee_postal_code">
          </mat-form-field>
        </div>

        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>Consignee Details</mat-expansion-panel-header>
          <div class="checkbox-group">
            <mat-checkbox formControlName="consignee_loading_dock">Loading Dock</mat-checkbox>
            <mat-checkbox formControlName="consignee_pickup_tailgate">Tailgate at Delivery</mat-checkbox>
            <mat-checkbox formControlName="consignee_truck_space">Truck Space</mat-checkbox>
            <mat-checkbox formControlName="consignee_pickup_straight_truck">Straight Truck</mat-checkbox>
            <mat-checkbox formControlName="consignee_bol_required">Requires BOL</mat-checkbox>
          </div>
        </mat-expansion-panel>

        <div class="row">
          <mat-form-field appearance="outline"  color="primary" class="enhanced-input">
            <mat-label>Delivery Reference</mat-label>
            <input matInput formControlName="consignee_delivery_reference">
          </mat-form-field>
          <mat-form-field appearance="outline"  color="primary" class="enhanced-input">
            <mat-label>Estimated Delivery Date</mat-label>
            <input matInput [matDatepicker]="consigneeEstimatedPicker" formControlName="estimated_date_consignee">
            <mat-datepicker-toggle matIconSuffix [for]="consigneeEstimatedPicker"></mat-datepicker-toggle>
            <mat-datepicker #consigneeEstimatedPicker></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="outline"  color="primary" class="enhanced-input">
            <mat-label>Delivery Time</mat-label>
            <input matInput type="time" formControlName="estimated_time_end_consignee">
          </mat-form-field>
        </div>

        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>Location Type</mat-expansion-panel-header>
          <div class="checkbox-group">
            <mat-checkbox formControlName="consignee_is_residential">Residential</mat-checkbox>
            <mat-checkbox formControlName="consignee_is_commercial">Commercial</mat-checkbox>
            <mat-checkbox formControlName="consignee_is_job_site">Job Site</mat-checkbox>
          </div>
        </mat-expansion-panel>

        <div *ngIf="consigneeForm.get('consignee_is_job_site')!.value">
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>Job Site Details</mat-expansion-panel-header>
            <div class="checkbox-group">
              <mat-checkbox formControlName="consignee_lift_lull">Forklift or Lull</mat-checkbox>
              <mat-checkbox formControlName="consignee_call_site">Call Site</mat-checkbox>
              <mat-checkbox formControlName="consignee_unmanned_job_site">Unmanned Job Site</mat-checkbox>
              <mat-form-field appearance="outline"  color="primary" class="enhanced-input">
                <mat-label>Job Site Contact Name</mat-label>
                <input matInput formControlName="consignee_job_site_contact_name">
              </mat-form-field>
              <mat-form-field appearance="outline"  color="primary" class="enhanced-input">
                <mat-label>Job Site Contact Phone</mat-label>
                <input matInput formControlName="consignee_job_site_contact_phone">
              </mat-form-field>
            </div>
          </mat-expansion-panel>
        </div>

        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>Other Site Info</mat-expansion-panel-header>
          <div class="checkbox-group">
            <mat-checkbox formControlName="consignee_is_convention_center">Convention Center</mat-checkbox>
            <mat-checkbox formControlName="consignee_is_pop_up">Pop‑Up Store</mat-checkbox>
            <mat-checkbox formControlName="appointment_consignee">Appointment required?</mat-checkbox>
          </div>
        </mat-expansion-panel>

        <div *ngIf="consigneeForm.get('appointment_consignee')!.value" class="row">
          <mat-form-field appearance="outline"  color="primary" class="enhanced-input">
            <mat-label>Delivery Date</mat-label>
            <input matInput [matDatepicker]="consigneeAppointmentPicker" formControlName="appointment_date_consignee">
            <mat-datepicker-toggle matIconSuffix [for]="consigneeAppointmentPicker"></mat-datepicker-toggle>
            <mat-datepicker #consigneeAppointmentPicker></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="outline"  color="primary" class="enhanced-input">
            <mat-label>Window Start</mat-label>
            <input matInput type="time" formControlName="appointment_time_start_consignee">
          </mat-form-field>
          <mat-form-field appearance="outline"  color="primary" class="enhanced-input">
            <mat-label>Window End</mat-label>
            <input matInput type="time" formControlName="appointment_time_end_consignee">
          </mat-form-field>
        </div>

        <div class="actions">
          <button mat-button color="accent" matStepperPrevious>Back</button>
          <button mat-raised-button color="primary" matStepperNext [disabled]="consigneeForm.invalid">Next</button>
        </div>
      </form>
    </mat-card>
  </mat-step>

  <!-- Step 4: Manifest Load -->
  <mat-step [stepControl]="loadDetailsForm">
    <ng-template matStepLabel>
      <i class="fas fa-truck-loading step-label__icon"></i>Manifest Load
    </ng-template>
    <mat-card class="step-card">
      <form [formGroup]="loadDetailsForm">

        <div class="row col-3">
          <mat-form-field appearance="outline"  color="primary" class="enhanced-input">
            <mat-label>Order Scope</mat-label>
            <input matInput formControlName="order_scope">
          </mat-form-field>
          <mat-form-field appearance="outline"  color="primary" class="enhanced-input">
            <mat-label>Secondary Scope</mat-label>
            <input matInput formControlName="order_scope_secondary">
          </mat-form-field>
        </div>

        <mat-expansion-panel formGroupName="lading_type" [expanded]="true">
          <mat-expansion-panel-header>Lading Type</mat-expansion-panel-header>
          <div class="checkbox-group">
            <mat-checkbox formControlName="usa_domestic">USA Domestic</mat-checkbox>
            <mat-checkbox formControlName="canada_domestic">Canada Domestic</mat-checkbox>
            <mat-checkbox formControlName="usa_crossborder">USA Crossborder</mat-checkbox>
            <mat-checkbox formControlName="canada_crossborder">Canada Crossborder</mat-checkbox>
            <mat-form-field *ngIf="loadDetailsForm.get('lading_type.usa_crossborder')!.value || loadDetailsForm.get('lading_type.canada_crossborder')!.value" appearance="fill" color="primary" class="enhanced-input">
              <mat-label>Customs Broker</mat-label>
              <input matInput formControlName="custom_broker_name">
            </mat-form-field>
            <mat-checkbox formControlName="air_freight">Air Freight</mat-checkbox>
            <mat-checkbox formControlName="client_generated">Client Generated</mat-checkbox>
            <mat-checkbox formControlName="local_delivery">Local Delivery</mat-checkbox>
            <mat-checkbox formControlName="ocean_freight">Ocean Freight</mat-checkbox>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel formGroupName="packaging_type" [expanded]="true">
          <mat-expansion-panel-header>Packaging Type</mat-expansion-panel-header>
          <div class="checkbox-group">
            <mat-checkbox formControlName="palleted">Palleted</mat-checkbox>
            <mat-checkbox formControlName="carton">Carton</mat-checkbox>
            <mat-checkbox formControlName="crate">Crate</mat-checkbox>
            <mat-checkbox formControlName="loose_floor">Loose/Floor</mat-checkbox>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel formGroupName="operations" [expanded]="true">
          <mat-expansion-panel-header>Operations</mat-expansion-panel-header>
          <div class="checkbox-group">
            <mat-checkbox formControlName="carrier_rated">Carrier Rated</mat-checkbox>
            <mat-checkbox formControlName="carrier_rerated">Carrier Re‑Rated</mat-checkbox>
            <mat-checkbox formControlName="straps_bars">Straps & Bars</mat-checkbox>
            <mat-checkbox formControlName="protective_equipment">Protective Equipment</mat-checkbox>
            <mat-form-field appearance="outline"  color="primary" class="enhanced-input">
              <mat-label>Operations Notation</mat-label>
              <input matInput formControlName="operations_notation">
            </mat-form-field>
          </div>
        </mat-expansion-panel>

        <div formGroupName="equipment" class="row">
          <mat-form-field appearance="outline"  color="primary" class="enhanced-input">
            <mat-label>Type of Equipment</mat-label>
            <input matInput formControlName="type_of_equipment">
          </mat-form-field>
          <mat-form-field appearance="outline"  color="primary" class="enhanced-input">
            <mat-label>Equipment Options</mat-label>
            <input matInput formControlName="equipment_options">
          </mat-form-field>
          <mat-form-field appearance="outline"  color="primary" class="enhanced-input">
            <mat-label>Partial or Full</mat-label>
            <mat-select formControlName="partial_or_full">
              <mat-option value="Partial">Partial</mat-option>
              <mat-option value="Full">Full</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <mat-expansion-panel formGroupName="household_import" [expanded]="true">
          <mat-expansion-panel-header>Household Import</mat-expansion-panel-header>
          <div class="checkbox-group">
            <mat-checkbox formControlName="importing_passport">Passports</mat-checkbox>
            <mat-checkbox formControlName="importing_work_permit_visa">Work Permit/Visa</mat-checkbox>
            <mat-checkbox formControlName="importing_inventory_listing">Inventory Listing</mat-checkbox>
            <mat-checkbox formControlName="importing_new_canadian_address">New Canadian Address</mat-checkbox>
            <mat-checkbox formControlName="importing_scale_tickets">Scale Tickets</mat-checkbox>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel formGroupName="household_export" [expanded]="true">
          <mat-expansion-panel-header>Household Export</mat-expansion-panel-header>
          <div class="checkbox-group">
            <mat-checkbox formControlName="exporting_passport">Passports</mat-checkbox>
            <mat-checkbox formControlName="exporting_form_3299">Form 3299</mat-checkbox>
            <mat-checkbox formControlName="exporting_power_of_attorney">Power of Attorney</mat-checkbox>
            <mat-checkbox formControlName="exporting_supplemental_declaration">Supplemental Declaration</mat-checkbox>
            <mat-checkbox formControlName="exporting_inventory_listing">Inventory Listing</mat-checkbox>
            <mat-checkbox formControlName="exporting_i94">I-94 Card</mat-checkbox>
            <mat-checkbox formControlName="exporting_scale_tickets">Scale Tickets</mat-checkbox>
          </div>
        </mat-expansion-panel>

        <div formArrayName="pallets_products">
          <button mat-mini-fab color="primary" (click)="addPalletProductSet()">
            <mat-icon>add</mat-icon>
          </button>
          <mat-card *ngFor="let grp of pallets_products.controls; let i = index" [formGroupName]="i">
            <mat-button-toggle-group formControlName="mode">
              <mat-button-toggle value="pallet">Pallets</mat-button-toggle>
              <mat-button-toggle value="product">Products</mat-button-toggle>
            </mat-button-toggle-group>

            <div *ngIf="grp.get('mode')!.value === 'pallet'" class="row">
              <mat-form-field appearance="outline"  color="primary" class="enhanced-input"><input matInput placeholder="# Pallets" formControlName="pallet_num"></mat-form-field>
              <mat-form-field appearance="outline"  color="primary" class="enhanced-input"><input matInput placeholder="Length" formControlName="pallet_length"></mat-form-field>
              <mat-form-field appearance="outline"  color="primary" class="enhanced-input"><input matInput placeholder="Width" formControlName="pallet_width"></mat-form-field>
              <mat-form-field appearance="outline"  color="primary" class="enhanced-input"><input matInput placeholder="Height" formControlName="pallet_height"></mat-form-field>
              <mat-form-field appearance="outline"  color="primary" class="enhanced-input"><input matInput placeholder="Weight" formControlName="pallet_weight"></mat-form-field>
            </div>

            <div *ngIf="grp.get('mode')!.value === 'product'" class="row">
              <mat-form-field appearance="outline"  color="primary" class="enhanced-input"><input matInput placeholder="Model #" formControlName="product_model_number"></mat-form-field>
              <mat-form-field appearance="outline"  color="primary" class="enhanced-input"><input matInput placeholder="Qty" formControlName="product_quantity"></mat-form-field>
              <mat-form-field appearance="outline"  color="primary" class="enhanced-input"><input matInput placeholder="Length" formControlName="product_length"></mat-form-field>
              <mat-form-field appearance="outline"  color="primary" class="enhanced-input"><input matInput placeholder="Width" formControlName="product_width"></mat-form-field>
              <mat-form-field appearance="outline"  color="primary" class="enhanced-input"><input matInput placeholder="Height" formControlName="product_height"></mat-form-field>
              <mat-form-field appearance="outline"  color="primary" class="enhanced-input"><input matInput placeholder="Weight" formControlName="product_weight"></mat-form-field>
              <mat-form-field appearance="outline"  color="primary" class="enhanced-input" class="full-width"><input matInput placeholder="Description" formControlName="product_description"></mat-form-field>
            </div>

            <button mat-mini-fab color="warn" (click)="removePalletProductSet(i)">
              <mat-icon>delete</mat-icon>
            </button>
          </mat-card>
        </div>

        <div formGroupName="additional_info" class="row">
          <mat-form-field appearance="outline"  color="primary" class="enhanced-input"><mat-label>Product Status</mat-label>
            <mat-select formControlName="product_status">
              <mat-option value="1">New</mat-option>
              <mat-option value="2">Used</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline"  color="primary" class="enhanced-input"><mat-label>Booking #</mat-label><input matInput formControlName="booking_number"></mat-form-field>
          <mat-form-field appearance="outline"  color="primary" class="enhanced-input"><mat-label>Release #</mat-label><input matInput formControlName="release_number"></mat-form-field>
          <mat-form-field appearance="outline"  color="primary" class="enhanced-input"><mat-label>BOL #</mat-label><input matInput formControlName="lading_number"></mat-form-field>
          <mat-form-field appearance="outline"  color="primary" class="enhanced-input"><mat-label>Trip #</mat-label><input matInput formControlName="trip_number"></mat-form-field>
          <mat-form-field appearance="outline"  color="primary" class="enhanced-input"><mat-label>Shipment #</mat-label><input matInput formControlName="shipment_number"></mat-form-field>
          <mat-form-field appearance="outline"  color="primary" class="enhanced-input"><mat-label>Requirements</mat-label><input matInput formControlName="requirements"></mat-form-field>
          <mat-form-field appearance="outline"  color="primary" class="enhanced-input"><mat-label>Details</mat-label><textarea matInput formControlName="load_details"></textarea></mat-form-field>
          <mat-form-field appearance="outline"  color="primary" class="enhanced-input"><mat-label>Special Info</mat-label><textarea matInput formControlName="load_special_info"></textarea></mat-form-field>
          <mat-form-field appearance="outline"  color="primary" class="enhanced-input"><mat-label>Load Length</mat-label><input matInput formControlName="load_length"></mat-form-field>
          <mat-form-field appearance="outline"  color="primary" class="enhanced-input"><mat-label>Value Unit</mat-label>
            <mat-select formControlName="load_value_unit">
              <mat-option value="USD">USD</mat-option>
              <mat-option value="CND">CND</mat-option>
              <mat-option value="OTHER">OTHER</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline"  color="primary" class="enhanced-input"><mat-label>Load Value</mat-label><input matInput formControlName="load_value"></mat-form-field>
        </div>

        <div class="actions">
          <button mat-button color="accent" matStepperPrevious>Back</button>
          <button mat-raised-button color="primary" matStepperNext>Next</button>
        </div>
      </form>
    </mat-card>
  </mat-step>

  <!-- Step 5: Summon Rates -->
  <mat-step [stepControl]="ratesForm">
    <ng-template matStepLabel>
      <i class="fas fa-dollar-sign step-label__icon"></i>Summon Rates
    </ng-template>
    <mat-card class="step-card">
      <form [formGroup]="ratesForm">

        <mat-form-field appearance="outline"  color="primary" class="enhanced-input">
          <mat-label>Carrier Company</mat-label>
          <input matInput formControlName="carrier_company_name">
        </mat-form-field>

        <mat-form-field appearance="outline"  color="primary" class="enhanced-input">
          <mat-label>Shipper Radius</mat-label>
          <input matInput formControlName="shipper_radius">
        </mat-form-field>

        <mat-form-field appearance="outline"  color="primary" class="enhanced-input">
          <mat-label>Consignee Radius</mat-label>
          <input matInput formControlName="consignee_radius">
        </mat-form-field>

        <div class="actions">
          <button mat-button color="accent" matStepperPrevious>Back</button>
          <button mat-raised-button color="primary" (click)="submit()">Submit</button>
        </div>
      </form>
    </mat-card>
  </mat-step>

</mat-horizontal-stepper>